export const siteConfig = {
  name: "Partition Stalls",
  legalName: "Partition Stalls",
  domain: "partitionstalls.com",
  url: "https://partitionstalls.com",
  phoneDisplay: "646-349-4040",
  phoneHref: "+16463494040",
  email: "info@partitionstalls.com",
  address: {
    streetAddress: "243 Grandview Ave",
    addressLocality: "Staten Island",
    addressRegion: "NY",
    postalCode: "10303",
    addressCountry: "US",
    display: "243 Grandview Ave, Staten Island, NY 10303",
    googleBusinessProfile: "https://www.google.com/maps/place/Partition+Stalls/data=!4m2!3m1!1s0x0:0x2b013d7bfc90a3df",
  },
  googleReviews: {
    placeId: "ChIJPUjcvj9bwokR36OQ_Hs9ASs",
    read: "https://g.page/r/Cd-jkPx7PQErEBM/",
    leave: "https://g.page/r/Cd-jkPx7PQErEBM/review",
  },
  serviceArea: "United States",
  social: {
    facebook: "https://www.facebook.com/people/Partition-Stalls/61586377095747/",
    instagram: "https://www.instagram.com/Partitionstalls",
  },
  description:
    "Nationwide supplier of commercial bathroom partitions, toilet stalls, restroom accessories, and Division 10 project support.",
} as const;

export const siteIdentityLinks = [
  siteConfig.address.googleBusinessProfile,
  siteConfig.social.facebook,
  siteConfig.social.instagram,
] as const;

export const assets = {
  logo: "/manus-storage/partition-stalls-logo-320_4c964cda.webp",
  footerLogo: "/manus-storage/partition-stalls-footer-matched_431f04b2.png",
  googleMapsLogoWhite: "/manus-storage/GoogleMaps_Logo_White_c36b2362.svg",
  googleMapsLogoDark: "/manus-storage/GoogleMaps_Logo_DarkGray_5b63b4ad.svg",
  googleReviewsBanner: "/manus-storage/google-reviews-banner_038bfacd.jpg",
  heroSmall: "/manus-storage/partition-hero-640_6af3d875.webp",
  heroMedium: "/manus-storage/partition-hero-960_16b15217.webp",
  hero: "/manus-storage/partition-hero-1280_42202825.webp",
  layoutDrawingSmall: "/manus-storage/partition-layout-520_662da240.webp",
  layoutDrawingMedium: "/manus-storage/partition-layout-800_2868c888.webp",
  layoutDrawing: "/manus-storage/partition-layout-1100_46d88d7b.webp",
  planningDrawingSmall: "/manus-storage/restroom-planning-drawing-720_eca69f3d.webp",
  planningDrawingMedium: "/manus-storage/restroom-planning-drawing-1200_42a76336.webp",
  planningDrawing: "/manus-storage/restroom-planning-drawing-1600_0729632d.webp",
  systemsCollageSmall: "/manus-storage/restroom-systems-collage-720_06509b93.webp",
  systemsCollageMedium: "/manus-storage/restroom-systems-collage-1200_c7cc69cb.webp",
  systemsCollage: "/manus-storage/restroom-systems-collage-1600_33cf0ea8.webp",
  quoteBanner: "/manus-storage/partition-quote-banner_9fdd6d16.webp",
  quoteIllustrationSmall: "/manus-storage/quote-partition-stalls-feet-360_94d96e4d.webp",
  quoteIllustrationMedium: "/manus-storage/quote-partition-stalls-feet-600_039e89d5.webp",
  quoteIllustrationLarge: "/manus-storage/quote-partition-stalls-feet-900_fdd173f9.webp",
  serviceAreasArtworkSmall: "/manus-storage/service-usa-partition-stalls-white-720_5d23e5b2.webp",
  serviceAreasArtworkMedium: "/manus-storage/service-usa-partition-stalls-white-1280_596e25d7.webp",
  serviceAreasArtworkLarge: "/manus-storage/service-usa-partition-stalls-white-1800_8cda8cf3.webp",
  nationwideShippingArtworkSmall: "/manus-storage/partition-stalls-continental-shipping-stalls-720_580cbb0e.webp",
  nationwideShippingArtworkMedium: "/manus-storage/partition-stalls-continental-shipping-stalls-1280_1fb5e1a4.webp",
  nationwideShippingArtworkLarge: "/manus-storage/partition-stalls-continental-shipping-stalls-1800_9aebc32d.webp",
  socialCard: "/social-preview.jpg",
  contactIcon: "/manus-storage/contact-icon_723c9f5e.webp",
  customSolutionsIcon: "/manus-storage/custom-solutions-icon_10222bf4.webp",
  division10Icon: "/manus-storage/division-10-icon_163a7a19.webp",
  experienceIcon: "/manus-storage/experience-icon_db4f88d6.webp",
  materialsIcon: "/manus-storage/materials-icon_152e8da2.webp",
  shippingIcon: "/manus-storage/nationwide-shipping-icon_74ecd8f5.webp",
  partitionBudgetVisuals: {
    "powder-coated-steel": "/manus-storage/partition-budget-powder-coated-steel-reference_6e401d4a.webp",
    "solid-plastic-hdpe": "/manus-storage/partition-budget-solid-plastic-hdpe-reference_00b5eee0.webp",
    phenolic: "/manus-storage/partition-budget-phenolic-reference_6c3ed07e.webp",
  },
  favicon32: "/manus-storage/favicon-32_a0889f38.png",
  favicon192: "/manus-storage/favicon-192_3ad36548.png",
  favicon512: "/manus-storage/favicon-512_af1d5e2d.png",
} as const;

export const realPhotos = {
  hero: {
    small: "/manus-storage/hero-restroom-720_de9ab618.webp",
    medium: "/manus-storage/hero-restroom-1200_35efc1ab.webp",
    large: "/manus-storage/hero-restroom-1600_c715dbd7.webp",
  },
  materials: {
    "powder-coated-steel": {
      small: "/manus-storage/powder-coated-steel-720_f2e8a97a.webp",
      large: "/manus-storage/powder-coated-steel-1280_6175f1b7.webp",
    },
    "plastic-laminate": {
      small: "/manus-storage/plastic-laminate-720_6dd92461.webp",
      large: "/manus-storage/plastic-laminate-1280_0990a448.webp",
    },
    "solid-plastic-hdpe": {
      small: "/manus-storage/solid-plastic-hdpe-720_8f13ab57.webp",
      large: "/manus-storage/solid-plastic-hdpe-1280_b554fe40.webp",
    },
    "stainless-steel": {
      small: "/manus-storage/stainless-steel-720_6c6d32ba.webp",
      large: "/manus-storage/stainless-steel-1280_336457d2.webp",
    },
    phenolic: {
      small: "/manus-storage/phenolic-720_5b360b8f.webp",
      large: "/manus-storage/phenolic-1280_ad2cdc1c.webp",
    },
  },
  projects: {
    ducksBallpark: {
      small: "/manus-storage/partition-stalls-ducks-ballpark-640_1a990cea.webp",
      medium: "/manus-storage/partition-stalls-ducks-ballpark-1000_7f68a24e.webp",
      large: "/manus-storage/partition-stalls-ducks-ballpark-1600_191e07a4.webp",
    },
    ducksBallparkField: {
      small: "/manus-storage/fairfield-ballpark-field-quintin-soloviev-640_d4fc83c0.webp",
      medium: "/manus-storage/fairfield-ballpark-field-quintin-soloviev-1000_6fa259ea.webp",
      large: "/manus-storage/fairfield-ballpark-field-quintin-soloviev-1600_3a0c5792.webp",
    },
    ducksBallparkAerial: {
      small: "/manus-storage/fairfield-ballpark-aerial-jimerb-640_dd337c9b.webp",
      medium: "/manus-storage/fairfield-ballpark-aerial-jimerb-1000_17b1d0e9.webp",
      large: "/manus-storage/fairfield-ballpark-aerial-jimerb-1600_5f1dd1cb.webp",
    },
    superParkRvPrimary: {
      small: "/manus-storage/super-park-rv-powder-coated-stalls-primary_558b09d4.webp",
      medium: "/manus-storage/super-park-rv-powder-coated-stalls-primary_558b09d4.webp",
      large: "/manus-storage/super-park-rv-powder-coated-stalls-primary_558b09d4.webp",
    },
    superParkRvAngle: {
      small: "/manus-storage/super-park-rv-powder-coated-stalls-angle_523c0367.webp",
      medium: "/manus-storage/super-park-rv-powder-coated-stalls-angle_523c0367.webp",
      large: "/manus-storage/super-park-rv-powder-coated-stalls-angle_523c0367.webp",
    },
    superParkRvHeadrail: {
      small: "/manus-storage/super-park-rv-powder-coated-stalls-headrail_0f0f87f5.webp",
      medium: "/manus-storage/super-park-rv-powder-coated-stalls-headrail_0f0f87f5.webp",
      large: "/manus-storage/super-park-rv-powder-coated-stalls-headrail_0f0f87f5.webp",
    },
    compalGeorgetownStainlessPrimary: {
      small: "/manus-storage/compal-georgetown-stainless-primary-640_021006c3.webp",
      medium: "/manus-storage/compal-georgetown-stainless-primary-1000_0830fb50.webp",
      large: "/manus-storage/compal-georgetown-stainless-primary-2910_0d94fccd.webp",
    },
    compalGeorgetownStainlessScreen: {
      small: "/manus-storage/compal-georgetown-stainless-screen-640_a4f7c15f.webp",
      medium: "/manus-storage/compal-georgetown-stainless-screen-1000_ba3048c4.webp",
      large: "/manus-storage/compal-georgetown-stainless-screen-1570_7bfa2f77.webp",
    },
    outdoorResortIndio: {
      small: "/manus-storage/outdoor-resort-indio-plastic-laminate-stalls_790768b1.webp",
      medium: "/manus-storage/outdoor-resort-indio-plastic-laminate-stalls_790768b1.webp",
      large: "/manus-storage/outdoor-resort-indio-plastic-laminate-stalls_790768b1.webp",
    },
    hollowParkWoodbury: {
      small: "/manus-storage/hollow-park-woodbury-ct-restroom-partitions_4f89baf8.webp",
      medium: "/manus-storage/hollow-park-woodbury-ct-restroom-partitions_4f89baf8.webp",
      large: "/manus-storage/hollow-park-woodbury-ct-restroom-partitions_4f89baf8.webp",
    },
    veteransMemorialEastHartfordPrimary: {
      small: "/manus-storage/veterans-memorial-clubhouse-east-hartford-primary-small_dcf1e2f0.webp",
      medium: "/manus-storage/veterans-memorial-clubhouse-east-hartford-primary-medium_7c3f350a.webp",
      large: "/manus-storage/veterans-memorial-clubhouse-east-hartford-primary-large_6b808b8b.webp",
    },
    veteransMemorialEastHartfordWide: {
      small: "/manus-storage/veterans-memorial-clubhouse-east-hartford-accessible-stall-small_9eccc410.webp",
      medium: "/manus-storage/veterans-memorial-clubhouse-east-hartford-accessible-stall-medium_76374dcd.webp",
      large: "/manus-storage/veterans-memorial-clubhouse-east-hartford-accessible-stall-large_7ede2da9.webp",
    },
    kloecknerMiddletownPrimary: {
      small: "/manus-storage/kloeckner-middletown-primary_e4a89353.jpeg",
      medium: "/manus-storage/kloeckner-middletown-primary_e4a89353.jpeg",
      large: "/manus-storage/kloeckner-middletown-primary_e4a89353.jpeg",
    },
    kloecknerMiddletownWide: {
      small: "/manus-storage/kloeckner-middletown-wide_01a99305.jpeg",
      medium: "/manus-storage/kloeckner-middletown-wide_01a99305.jpeg",
      large: "/manus-storage/kloeckner-middletown-wide_01a99305.jpeg",
    },
    kloecknerMiddletownPortrait: {
      small: "/manus-storage/kloeckner-middletown-portrait_4918bf0a.jpeg",
      medium: "/manus-storage/kloeckner-middletown-portrait_4918bf0a.jpeg",
      large: "/manus-storage/kloeckner-middletown-portrait_4918bf0a.jpeg",
    },
    kloecknerMiddletownCompartments: {
      small: "/manus-storage/kloeckner-middletown-compartments_8b1ec63b.jpeg",
      medium: "/manus-storage/kloeckner-middletown-compartments_8b1ec63b.jpeg",
      large: "/manus-storage/kloeckner-middletown-compartments_8b1ec63b.jpeg",
    },
    ptsmcWallingfordPrimary: {
      small: "/manus-storage/ptsmc-wallingford-powder-coated-stalls-primary-small_7059ddf3.webp",
      medium: "/manus-storage/ptsmc-wallingford-powder-coated-stalls-primary-medium_e3c5c009.webp",
      large: "/manus-storage/ptsmc-wallingford-powder-coated-stalls-primary-large_19191cd4.webp",
    },
    ptsmcWallingfordAngle: {
      small: "/manus-storage/ptsmc-wallingford-powder-coated-stalls-angle-small_c810f22b.webp",
      medium: "/manus-storage/ptsmc-wallingford-powder-coated-stalls-angle-medium_6d339e67.webp",
      large: "/manus-storage/ptsmc-wallingford-powder-coated-stalls-angle-large_8dbeb50a.webp",
    },
    johnsTimesSquare: {
      small: "/manus-storage/johns-times-square-custom-pizza-color-steel-partition-small_97961f8f.webp",
      medium: "/manus-storage/johns-times-square-custom-pizza-color-steel-partition-large_e9b8bc77.webp",
      large: "/manus-storage/johns-times-square-custom-pizza-color-steel-partition-large_e9b8bc77.webp",
    },
    sepaMujerPatchogue: {
      small: "/manus-storage/sepa-mujer-patchogue-plastic-laminate-partition-small_8e129719.webp",
      medium: "/manus-storage/sepa-mujer-patchogue-plastic-laminate-partition-medium_e82568d3.webp",
      large: "/manus-storage/sepa-mujer-patchogue-plastic-laminate-partition-large_ba6267b5.webp",
    },
    pierSixtyStalls: {
      small: "/manus-storage/pier-sixty-chelsea-piers-stainless-stalls-small_40582466.webp",
      medium: "/manus-storage/pier-sixty-chelsea-piers-stainless-stalls-medium_82aec450.webp",
      large: "/manus-storage/pier-sixty-chelsea-piers-stainless-stalls-large_21a1fa64.webp",
    },
    pierSixtyUrinalScreens: {
      small: "/manus-storage/pier-sixty-chelsea-piers-stainless-urinal-screens-small_6e1e5747.webp",
      medium: "/manus-storage/pier-sixty-chelsea-piers-stainless-urinal-screens-medium_268b39b7.webp",
      large: "/manus-storage/pier-sixty-chelsea-piers-stainless-urinal-screens-large_d00b5fb2.webp",
    },
    onnuriFortLee: {
      small: "/manus-storage/onnuri-church-fort-lee-solid-plastic-stalls-small_03dedf8b.webp",
      medium: "/manus-storage/onnuri-church-fort-lee-solid-plastic-stalls-large_ffae8e57.webp",
      large: "/manus-storage/onnuri-church-fort-lee-solid-plastic-stalls-large_ffae8e57.webp",
    },
    robertSpearingParkRidge: {
      small: "/manus-storage/robert-spearing-funeral-home-stainless-steel-cleaned_c5d1f2e4.png",
      medium: "/manus-storage/robert-spearing-funeral-home-stainless-steel-cleaned_c5d1f2e4.png",
      large: "/manus-storage/robert-spearing-funeral-home-stainless-steel-cleaned_c5d1f2e4.png",
    },
    youthbuildNewarkSolidPlasticPrimary: {
      small: "/manus-storage/youthbuild-newark-solid-plastic-primary_ebf4a1bd.jpeg",
      medium: "/manus-storage/youthbuild-newark-solid-plastic-primary_ebf4a1bd.jpeg",
      large: "/manus-storage/youthbuild-newark-solid-plastic-primary_ebf4a1bd.jpeg",
    },
    youthbuildNewarkSolidPlasticGallery: {
      small: "/manus-storage/youthbuild-newark-solid-plastic-gallery_f3d93b30.jpeg",
      medium: "/manus-storage/youthbuild-newark-solid-plastic-gallery_f3d93b30.jpeg",
      large: "/manus-storage/youthbuild-newark-solid-plastic-gallery_f3d93b30.jpeg",
    },
    youthbuildNewarkPowderCoatedPrimary: {
      small: "/manus-storage/youthbuild-newark-powder-coated-steel-primary_e16a83a1.webp",
      medium: "/manus-storage/youthbuild-newark-powder-coated-steel-primary_e16a83a1.webp",
      large: "/manus-storage/youthbuild-newark-powder-coated-steel-primary_e16a83a1.webp",
    },
    youthbuildNewarkPowderCoatedGallery: {
      small: "/manus-storage/youthbuild-newark-powder-coated-steel-gallery_77f29e00.webp",
      medium: "/manus-storage/youthbuild-newark-powder-coated-steel-gallery_77f29e00.webp",
      large: "/manus-storage/youthbuild-newark-powder-coated-steel-gallery_77f29e00.webp",
    },
    proCraftersTelford: {
      small: "/manus-storage/pro-crafters-telford-pa-restroom-partitions_b2321b88.webp",
      medium: "/manus-storage/pro-crafters-telford-pa-restroom-partitions_b2321b88.webp",
      large: "/manus-storage/pro-crafters-telford-pa-restroom-partitions_b2321b88.webp",
    },
    bethelDeliveranceWyncote: {
      small: "/manus-storage/bethel-deliverance-wyncote-pa-restroom-partitions_8228b9c6.webp",
      medium: "/manus-storage/bethel-deliverance-wyncote-pa-restroom-partitions_8228b9c6.webp",
      large: "/manus-storage/bethel-deliverance-wyncote-pa-restroom-partitions_8228b9c6.webp",
    },
    saffronMiddletown: {
      small: "/manus-storage/saffron-middletown-ny-restroom-partitions_b9d8be97.webp",
      medium: "/manus-storage/saffron-middletown-ny-restroom-partitions_b9d8be97.webp",
      large: "/manus-storage/saffron-middletown-ny-restroom-partitions_b9d8be97.webp",
    },
    hewlettWoodmerePrimary: {
      small: "/manus-storage/hewlett-woodmere-solid-plastic-primary_c1dfbb3e.webp",
      medium: "/manus-storage/hewlett-woodmere-solid-plastic-primary_c1dfbb3e.webp",
      large: "/manus-storage/hewlett-woodmere-solid-plastic-primary_c1dfbb3e.webp",
    },
    hewlettWoodmereGallery: {
      small: "/manus-storage/hewlett-woodmere-solid-plastic-gallery_d91bee7f.webp",
      medium: "/manus-storage/hewlett-woodmere-solid-plastic-gallery_d91bee7f.webp",
      large: "/manus-storage/hewlett-woodmere-solid-plastic-gallery_d91bee7f.webp",
    },
    buchananElementaryPrimary: {
      small: "/manus-storage/buchanan-elementary-solid-plastic-primary_d29939b9.jpeg",
      medium: "/manus-storage/buchanan-elementary-solid-plastic-primary_d29939b9.jpeg",
      large: "/manus-storage/buchanan-elementary-solid-plastic-primary_d29939b9.jpeg",
    },
    buchananElementaryAngle: {
      small: "/manus-storage/buchanan-elementary-solid-plastic-stalls-angle_0e19fa18.jpeg",
      medium: "/manus-storage/buchanan-elementary-solid-plastic-stalls-angle_0e19fa18.jpeg",
      large: "/manus-storage/buchanan-elementary-solid-plastic-stalls-angle_0e19fa18.jpeg",
    },
    buchananElementaryWide: {
      small: "/manus-storage/buchanan-elementary-solid-plastic-stalls-wide_648ca4d6.jpeg",
      medium: "/manus-storage/buchanan-elementary-solid-plastic-stalls-wide_648ca4d6.jpeg",
      large: "/manus-storage/buchanan-elementary-solid-plastic-stalls-wide_648ca4d6.jpeg",
    },
    buchananElementaryScreen: {
      small: "/manus-storage/buchanan-elementary-solid-plastic-urinal-screen_7efd01d9.jpeg",
      medium: "/manus-storage/buchanan-elementary-solid-plastic-urinal-screen_7efd01d9.jpeg",
      large: "/manus-storage/buchanan-elementary-solid-plastic-urinal-screen_7efd01d9.jpeg",
    },
    cineMagicLicPrimary: {
      small: "/manus-storage/cinemagic-lic-powder-coated-primary-small_8234eb90.webp",
      medium: "/manus-storage/cinemagic-lic-powder-coated-primary-medium_034dcbeb.webp",
      large: "/manus-storage/cinemagic-lic-powder-coated-primary-large_d5998ef8.webp",
    },
    cineMagicLicAngle: {
      small: "/manus-storage/cinemagic-lic-powder-coated-angle-small_636a7e57.webp",
      medium: "/manus-storage/cinemagic-lic-powder-coated-angle-medium_4a6277ef.webp",
      large: "/manus-storage/cinemagic-lic-powder-coated-angle-large_b93d8d31.webp",
    },
    newPaltzHighSchoolPrimary: {
      small: "/manus-storage/new-paltz-high-school-primary-restored-small_4b87fcec.webp",
      medium: "/manus-storage/new-paltz-high-school-primary-restored-medium_baea123d.webp",
      large: "/manus-storage/new-paltz-high-school-primary-restored-large_f8700333.webp",
    },
    newPaltzHighSchoolAngle: {
      small: "/manus-storage/new-paltz-high-school-angle-restored-small_149e9736.webp",
      medium: "/manus-storage/new-paltz-high-school-angle-restored-medium_38b75ad8.webp",
      large: "/manus-storage/new-paltz-high-school-angle-restored-large_52e8fde9.webp",
    },
    newPaltzHighSchoolWide: {
      small: "/manus-storage/new-paltz-high-school-wide-restored-small_78e31343.webp",
      medium: "/manus-storage/new-paltz-high-school-wide-restored-medium_c32628bb.webp",
      large: "/manus-storage/new-paltz-high-school-wide-restored-large_11373507.webp",
    },
    itaKitchenGardenCityPrimary: {
      small: "/manus-storage/ita-kitchen-garden-city-primary-small_de21b7d6.webp",
      medium: "/manus-storage/ita-kitchen-garden-city-primary-medium_7327deff.webp",
      large: "/manus-storage/ita-kitchen-garden-city-primary-large_0a589770.webp",
    },
    itaKitchenGardenCityAngle: {
      small: "/manus-storage/ita-kitchen-garden-city-angle-small_421ccc16.webp",
      medium: "/manus-storage/ita-kitchen-garden-city-angle-medium_7ebd99e4.webp",
      large: "/manus-storage/ita-kitchen-garden-city-angle-large_4a62bde7.webp",
    },
    metropolitanWarehousePerthAmboyPrimary: {
      small: "/manus-storage/metropolitan-warehouse-perth-amboy-primary-small_d3669934.webp",
      medium: "/manus-storage/metropolitan-warehouse-perth-amboy-primary-medium_072df1c5.webp",
      large: "/manus-storage/metropolitan-warehouse-perth-amboy-primary-large_4b77b20e.webp",
    },
    metropolitanWarehousePerthAmboyAccessible: {
      small: "/manus-storage/metropolitan-warehouse-perth-amboy-accessible-small_4c996407.webp",
      medium: "/manus-storage/metropolitan-warehouse-perth-amboy-accessible-medium_b6e492cc.webp",
      large: "/manus-storage/metropolitan-warehouse-perth-amboy-accessible-large_b6560c18.webp",
    },
    metropolitanWarehousePerthAmboyAngle: {
      small: "/manus-storage/metropolitan-warehouse-perth-amboy-angle-small_8b7c1cba.webp",
      medium: "/manus-storage/metropolitan-warehouse-perth-amboy-angle-medium_9fd081bd.webp",
      large: "/manus-storage/metropolitan-warehouse-perth-amboy-angle-large_09e359f6.webp",
    },
    casaMezcalBurgundyPrimary: {
      small: "/manus-storage/PHOTO-2026-08-27-15-51-36_6da06c6c.jpeg",
      medium: "/manus-storage/PHOTO-2026-08-27-15-51-36_6da06c6c.jpeg",
      large: "/manus-storage/PHOTO-2026-08-27-15-51-36_6da06c6c.jpeg",
    },
    casaMezcalBurgundyGallery: {
      small: "/manus-storage/PHOTO-2026-08-27-15-51-41_5bcdac5b.jpeg",
      medium: "/manus-storage/PHOTO-2026-08-27-15-51-41_5bcdac5b.jpeg",
      large: "/manus-storage/PHOTO-2026-08-27-15-51-41_5bcdac5b.jpeg",
    },
    casaMezcalForestGreenGrabBars: {
      small: "/manus-storage/PHOTO-2026-08-27-15-51-52_7ebcb917.jpeg",
      medium: "/manus-storage/PHOTO-2026-08-27-15-51-52_7ebcb917.jpeg",
      large: "/manus-storage/PHOTO-2026-08-27-15-51-52_7ebcb917.jpeg",
    },
    casaMezcalForestGreenGallery: {
      small: "/manus-storage/PHOTO-2026-08-27-15-51-59_f7eecdc5.jpeg",
      medium: "/manus-storage/PHOTO-2026-08-27-15-51-59_f7eecdc5.jpeg",
      large: "/manus-storage/PHOTO-2026-08-27-15-51-59_f7eecdc5.jpeg",
    },
    casaMezcalGreenGrabBars: {
      small: "/manus-storage/PHOTO-2026-08-27-15-52-15_489e8503.jpeg",
      medium: "/manus-storage/PHOTO-2026-08-27-15-52-15_489e8503.jpeg",
      large: "/manus-storage/PHOTO-2026-08-27-15-52-15_489e8503.jpeg",
    },
    casaMezcalBurgundyGrabBars: {
      small: "/manus-storage/PHOTO-2026-08-27-15-52-21_064f96f1.jpeg",
      medium: "/manus-storage/PHOTO-2026-08-27-15-52-21_064f96f1.jpeg",
      large: "/manus-storage/PHOTO-2026-08-27-15-52-21_064f96f1.jpeg",
    },
    laMaisonGreenwichPrimary: {
      small: "/manus-storage/la-maison-greenwich-stall-row-640_99c95702.webp",
      medium: "/manus-storage/la-maison-greenwich-stall-row-900_49d9f05c.webp",
      large: "/manus-storage/la-maison-greenwich-stall-row-1153_012621a6.webp",
    },
    laMaisonGreenwichWide: {
      small: "/manus-storage/la-maison-greenwich-stall-row-wide-640_e11dd096.webp",
      medium: "/manus-storage/la-maison-greenwich-stall-row-wide-900_55f45fbc.webp",
      large: "/manus-storage/la-maison-greenwich-stall-row-wide-1153_2705b9fd.webp",
    },
    trainingStationPortWashingtonPrimary: {
      small: "/manus-storage/training-station-port-washington-primary-640_9fcdb02b.webp",
      medium: "/manus-storage/training-station-port-washington-primary-1000_37000f4e.webp",
      large: "/manus-storage/training-station-port-washington-primary-1201_c97f33a4.webp",
    },
    trainingStationPortWashingtonGallery: {
      small: "/manus-storage/training-station-port-washington-gallery-640_2d921b5d.webp",
      medium: "/manus-storage/training-station-port-washington-gallery-1000_3a24fa39.webp",
      large: "/manus-storage/training-station-port-washington-gallery-1600_838b84c4.webp",
    },
    highBanksSpeedwayPuebloPrimary: {
      small: "/manus-storage/high-banks-speedway-pueblo-restroom-stalls-primary_ee710015.webp",
      medium: "/manus-storage/high-banks-speedway-pueblo-restroom-stalls-primary_ee710015.webp",
      large: "/manus-storage/high-banks-speedway-pueblo-restroom-stalls-primary_ee710015.webp",
    },
    highBanksSpeedwayPuebloScreen: {
      small: "/manus-storage/high-banks-speedway-pueblo-restroom-screen-detail_8af80087.webp",
      medium: "/manus-storage/high-banks-speedway-pueblo-restroom-screen-detail_8af80087.webp",
      large: "/manus-storage/high-banks-speedway-pueblo-restroom-screen-detail_8af80087.webp",
    },
    spiritLifeMinistriesWilmingtonPrimary: {
      small: "/manus-storage/spirit-life-ministries-wilmington-primary-640_ccf35be2.webp",
      medium: "/manus-storage/spirit-life-ministries-wilmington-primary-1000_6d163352.webp",
      large: "/manus-storage/spirit-life-ministries-wilmington-primary-1098_630b7557.webp",
    },
    dark: {
      small: "/manus-storage/project-dark-stalls-720_51cf1b07.webp",
      large: "/manus-storage/project-dark-stalls-1280_b0807562.webp",
    },
    white: {
      small: "/manus-storage/project-white-stalls-720_869c53e6.webp",
      large: "/manus-storage/project-white-stalls-1280_de3277a1.webp",
    },
    blue: {
      small: "/manus-storage/project-blue-stalls-720_60403a1b.webp",
      large: "/manus-storage/project-blue-stalls-1280_429e2abc.webp",
    },
  },
  homepageCategories: {
    partitions: {
      small: "/manus-storage/homepage-stainless-partitions-product-720_a0c573aa.webp",
      large: "/manus-storage/homepage-stainless-partitions-product-900_3e0b7273.webp",
    },
    accessories: {
      small: "/manus-storage/homepage-accessories-approved-720_96898884.webp",
      large: "/manus-storage/homepage-accessories-approved-900_2514a643.webp",
    },
  },
  accessories: {
    modernMatteBlack: {
      small: "/manus-storage/accessories-matte-black-hero-720_0de55861.webp",
      medium: "/manus-storage/accessories-matte-black-hero-1280_c5d2dd6a.webp",
      large: "/manus-storage/accessories-matte-black-hero-1600_0215b6a1.webp",
    },
    grabBars: {
      small: "/manus-storage/accessory-grab-bars-720_f7dc7222.webp",
      large: "/manus-storage/accessory-grab-bars-1280_a5a7cf3e.webp",
    },
    handDryers: {
      small: "/manus-storage/accessory-hand-dryers-720_16668d87.webp",
      large: "/manus-storage/accessory-hand-dryers-1280_afbcdeba.webp",
    },
    mirrors: {
      small: "/manus-storage/accessory-mirrors-720_a7eff1e3.webp",
      large: "/manus-storage/accessory-mirrors-1280_6583edb2.webp",
    },
    paperDispensers: {
      small: "/manus-storage/accessory-paper-dispensers-720_4a526b81.webp",
      large: "/manus-storage/accessory-paper-dispensers-1280_cd0d0ad1.webp",
    },
    restroom: {
      small: "/manus-storage/accessory-restroom-720_c8dee51f.webp",
      large: "/manus-storage/accessory-restroom-1280_7aca394c.webp",
    },
  },
} as const;

export type Material = {
  slug: string;
  number: string;
  name: "Powder Coated Steel" | "Plastic Laminate" | "Solid Plastic (HDPE)" | "Stainless Steel" | "Phenolic";
  shortLabel: string;
  summary: string;
  positioning: string;
  benefits: string[];
  idealUseCases: string[];
  specificationNotes: string[];
  appearance: string;
  maintenance: string;
  environment: string;
  metaDescription: string;
};

export const materials: Material[] = [
  {
    slug: "powder-coated-steel",
    number: "01",
    name: "Powder Coated Steel",
    shortLabel: "Practical value",
    summary:
      "A dependable, economical choice for standard commercial restrooms, with a clean painted finish and broad design flexibility.",
    positioning:
      "Powder Coated Steel partitions balance project cost, familiar construction, and a professional finished appearance. They are a practical starting point for dry, climate-controlled facilities where buyers need reliable commercial toilet compartments without stepping into premium material pricing.",
    benefits: [
      "Cost-conscious material option for many commercial projects",
      "Broad color selection for coordinating with interior finishes",
      "Lightweight panels that support straightforward handling and installation",
      "Familiar choice for renovations, tenant improvements, and new construction",
    ],
    idealUseCases: ["Office buildings", "Retail stores", "Restaurants", "Churches", "Light-use schools", "Tenant improvements"],
    specificationNotes: [
      "Confirm the mounting style and finished ceiling conditions",
      "Select a color that coordinates with tile, paint, and accessory finishes",
      "Use a more moisture-resistant material where washdown or persistent humidity is expected",
      "Verify door swing, accessible compartment dimensions, and hardware requirements",
    ],
    appearance:
      "A uniform baked-on color finish creates a clean, straightforward commercial look. Neutral tones work well for broad appeal, while deeper colors can create deliberate contrast within a simple restroom palette.",
    maintenance:
      "Routine cleaning with non-abrasive products helps preserve the finish. Prompt attention to chips or scratches is recommended in demanding facilities.",
    environment:
      "Best suited to dry interior restrooms with normal commercial use and controlled moisture exposure.",
    metaDescription:
      "Specify Powder Coated Steel commercial bathroom partitions for practical value, flexible colors, and dependable performance in dry commercial restrooms.",
  },
  {
    slug: "plastic-laminate",
    number: "02",
    name: "Plastic Laminate",
    shortLabel: "Design flexibility",
    summary:
      "A design-focused partition material with a wide range of decorative colors, patterns, and wood-look options for dry interiors.",
    positioning:
      "Plastic Laminate partitions give architects, designers, and facility owners greater control over the visual character of a commercial restroom. Their finished surfaces support coordinated interiors where appearance matters as much as everyday function.",
    benefits: [
      "Extensive decorative finish and pattern possibilities",
      "Warm, refined appearance for image-sensitive interiors",
      "Easy coordination with casework, wall panels, and interior palettes",
      "Strong fit for controlled, dry commercial restroom environments",
    ],
    idealUseCases: ["Corporate offices", "Hospitality", "Restaurants", "Churches", "Retail interiors", "Professional facilities"],
    specificationNotes: [
      "Keep the application to dry, climate-controlled interiors",
      "Coordinate face color, edge treatment, hardware, and accessory finishes",
      "Review panel direction and pattern repeat for wood-look or directional finishes",
      "Choose a moisture-resistant alternative for locker rooms, pools, or washdown areas",
    ],
    appearance:
      "Plastic Laminate offers the broadest decorative vocabulary of the five materials, from quiet neutrals to wood-inspired patterns and saturated accent colors.",
    maintenance:
      "Clean with mild, non-abrasive products and avoid prolonged water exposure at panel edges and joints.",
    environment:
      "Designed for dry interiors where humidity is controlled and direct water exposure is limited.",
    metaDescription:
      "Explore Plastic Laminate commercial bathroom partitions with broad color, pattern, and wood-look options for design-focused dry restroom interiors.",
  },
  {
    slug: "solid-plastic-hdpe",
    number: "03",
    name: "Solid Plastic (HDPE)",
    shortLabel: "High-traffic durability",
    summary:
      "A moisture-resistant, low-maintenance material built for high-use facilities, humid conditions, and demanding cleaning routines.",
    positioning:
      "Solid Plastic (HDPE) partitions are selected when durability and moisture resistance carry more weight than the lowest initial material cost. Their solid, color-through construction makes them a strong match for public, educational, recreational, and institutional environments.",
    benefits: [
      "Resists moisture in humid or frequently cleaned environments",
      "Color-through construction helps make everyday wear less visually prominent",
      "Durable choice for heavy-use and higher-abuse facilities",
      "Low-maintenance surface for long-term facility operations",
    ],
    idealUseCases: ["K–12 schools", "Parks", "Recreation centers", "Locker rooms", "Pools", "Transit facilities", "Stadiums"],
    specificationNotes: [
      "Confirm panel thickness, mounting style, and hardware package",
      "Coordinate textured or smooth finish preferences with cleaning expectations",
      "Review ventilation, door clearances, and accessible compartment layouts",
      "Consider facility traffic, vandalism exposure, and cleaning frequency",
    ],
    appearance:
      "Solid Plastic (HDPE) has a substantial, contemporary profile with integral color and a practical palette suited to schools, recreation, and public facilities.",
    maintenance:
      "The non-porous surface supports routine commercial cleaning and is well suited to facilities where partitions receive frequent attention.",
    environment:
      "Well suited to humid, wet, high-traffic, and demanding commercial restroom environments.",
    metaDescription:
      "Choose Solid Plastic (HDPE) bathroom partitions for moisture resistance, durability, and low-maintenance performance in high-traffic commercial restrooms.",
  },
  {
    slug: "stainless-steel",
    number: "04",
    name: "Stainless Steel",
    shortLabel: "Premium finish",
    summary:
      "A premium partition material with a crisp architectural appearance for high-profile and demanding commercial interiors.",
    positioning:
      "Stainless Steel partitions deliver a polished, durable visual statement for facilities where restroom quality contributes to the overall building experience. Their refined metal surface pairs naturally with stainless accessories and contemporary architectural finishes.",
    benefits: [
      "Premium architectural appearance for high-visibility restrooms",
      "Durable metal surface suited to demanding commercial use",
      "Natural coordination with stainless steel restroom accessories",
      "Timeless fit for modern, institutional, and hospitality interiors",
    ],
    idealUseCases: ["Airports", "Corporate headquarters", "Healthcare", "Hospitality", "Civic buildings", "High-end public facilities"],
    specificationNotes: [
      "Coordinate the partition finish with grab bars, dispensers, and exposed hardware",
      "Confirm finish direction and handling requirements before installation",
      "Review traffic level and cleaning practices for the selected surface finish",
      "Verify mounting style, ceiling height, and support conditions",
    ],
    appearance:
      "A crisp metal finish creates a precise, upscale restroom environment. Brushed appearances can coordinate visual texture across partitions and accessories.",
    maintenance:
      "Use cleaning products intended for stainless surfaces and follow the grain direction where applicable to maintain a consistent appearance.",
    environment:
      "Suitable for premium commercial interiors and demanding public facilities where appearance and durability are both priorities.",
    metaDescription:
      "Specify Stainless Steel commercial bathroom partitions for a premium architectural look, durable construction, and coordinated restroom finishes.",
  },
  {
    slug: "phenolic",
    number: "05",
    name: "Phenolic",
    shortLabel: "High-performance profile",
    summary:
      "A dense, durable, moisture-resistant panel material for high-performance restrooms that demand a refined compact profile.",
    positioning:
      "Phenolic partitions combine a slim, refined visual profile with the durability needed for institutional, healthcare, laboratory, aquatic, and high-traffic commercial settings. They are a strong specification choice where moisture, cleaning, and design performance must work together.",
    benefits: [
      "Dense construction for demanding commercial applications",
      "Moisture-resistant performance for humid and frequently cleaned spaces",
      "Refined compact profile for contemporary restroom design",
      "Broad fit across institutional, healthcare, academic, and aquatic facilities",
    ],
    idealUseCases: ["Healthcare facilities", "Laboratories", "Aquatic centers", "Universities", "Locker rooms", "High-performance interiors"],
    specificationNotes: [
      "Confirm finish, core appearance, panel thickness, and edge treatment",
      "Coordinate hardware type and mounting system with project performance goals",
      "Review chemical exposure and cleaning protocols with the project team",
      "Verify accessible compartment dimensions and support conditions",
    ],
    appearance:
      "Phenolic panels provide a clean, slender profile with a broad range of finish directions for contemporary institutional and commercial interiors.",
    maintenance:
      "The dense surface supports regular cleaning in high-use facilities; project-specific cleaning agents should be reviewed before use.",
    environment:
      "A strong fit for humid, high-traffic, institutional, healthcare, and specialty environments requiring a premium material solution.",
    metaDescription:
      "Explore Phenolic commercial bathroom partitions for dense, moisture-resistant performance and a refined profile in demanding restroom environments.",
  },
];

export type AccessoryItem = {
  name: string;
  description: string;
  configurations: string;
  specify: string;
};

export type AccessoryGroup = {
  id: string;
  number: string;
  name: string;
  intro: string;
  items: AccessoryItem[];
};

export const accessoryGroups: AccessoryGroup[] = [
  {
    id: "accessibility-safety",
    number: "01",
    name: "Accessibility & Safety",
    intro: "Commercial restroom components that support accessible layouts, user stability, and safer facility operation.",
    items: [
      { name: "Grab Bars", description: "Supportive stainless steel bars for accessible toilet compartments, showers, and changing areas.", configurations: "Straight, swing-up, wall-to-floor, and specialty configurations.", specify: "Length, diameter, finish, mounting condition, backing, and layout." },
      { name: "Shower Seats", description: "Wall-mounted seating for accessible showers, locker rooms, healthcare, and assisted-use facilities.", configurations: "Folding, fixed, rectangular, and L-shaped formats.", specify: "Seat size, support structure, wall backing, finish, and project accessibility requirements." },
      { name: "Accessible Accessories", description: "Coordinated fixtures positioned and selected for accessible commercial restroom layouts.", configurations: "Dispensers, mirrors, shelves, hooks, and combination units.", specify: "Mounting height, reach range, projection, clear floor space, and local code review." },
      { name: "Tub & Shower Accessories", description: "Commercial components for bathing, shower, locker room, and changing environments.", configurations: "Curtain rods, hooks, soap dishes, shelves, and support accessories.", specify: "Wet-area finish, mounting method, dimensions, and substrate." },
    ],
  },
  {
    id: "handwashing-hygiene",
    number: "02",
    name: "Handwashing & Hygiene",
    intro: "Dispensing and hand-drying solutions for high-use washroom counters, lavatories, and public hygiene stations.",
    items: [
      { name: "Soap Dispensers", description: "Commercial liquid or foam soap delivery for counters, walls, and coordinated wash stations.", configurations: "Manual, touch-free, surface-mounted, recessed, and counter-mounted.", specify: "Soap type, capacity, power source, refill access, finish, and mounting." },
      { name: "Hand Sanitizer Dispensers", description: "Dedicated hygiene dispensers for restroom entries, corridors, healthcare, and public facilities.", configurations: "Manual or automatic, wall-mounted, counter-mounted, or stand-mounted.", specify: "Sanitizer compatibility, capacity, power source, placement, and refill method." },
      { name: "Commercial Faucets", description: "Coordinated faucets for commercial lavatories and integrated handwashing stations.", configurations: "Manual, metering, sensor-operated, deck-mounted, and wall-mounted.", specify: "Power, flow, deck conditions, supply requirements, finish, and controls." },
      { name: "Hand Dryers", description: "Electric drying options for low-touch, paper-reduction, and high-traffic washroom programs.", configurations: "High-speed, recessed, surface-mounted, and accessible-profile models.", specify: "Voltage, mounting height, sound goals, projection, finish, and wall conditions." },
    ],
  },
  {
    id: "paper-waste",
    number: "03",
    name: "Paper & Waste",
    intro: "High-capacity dispensing and waste-handling products for efficient maintenance and consistent restroom operation.",
    items: [
      { name: "Paper Towel Dispensers", description: "Durable dispensing for folded, roll, and touch-free commercial paper towel systems.", configurations: "Surface-mounted, recessed, semi-recessed, manual, and automatic.", specify: "Paper format, capacity, power, refill access, projection, and finish." },
      { name: "Combination Towel/Waste Units", description: "Space-efficient assemblies that pair towel dispensing with integrated waste collection.", configurations: "Recessed, semi-recessed, surface-mounted, and automatic dispensing.", specify: "Wall depth, paper system, waste capacity, service access, and power." },
      { name: "Waste Receptacles", description: "Freestanding or built-in commercial waste collection for washrooms and common areas.", configurations: "Floor-standing, wall-mounted, recessed, open-top, and covered.", specify: "Capacity, liner access, fire-safety needs, finish, and mounting." },
      { name: "Sanitary Disposals", description: "Compact disposal units for private toilet compartments and women’s restroom programs.", configurations: "Wall-mounted, partition-mounted, recessed, and dual-access.", specify: "Mounting side, capacity, lid operation, finish, and service access." },
    ],
  },
  {
    id: "compartment-accessories",
    number: "04",
    name: "Toilet Compartment Accessories",
    intro: "Essential fixtures and replacement components for complete, coordinated commercial toilet compartments.",
    items: [
      { name: "Toilet Tissue Dispensers", description: "Commercial tissue dispensing for standard, jumbo, multi-roll, and controlled-use programs.", configurations: "Single-roll, multi-roll, jumbo-roll, recessed, and partition-mounted.", specify: "Roll format, capacity, mounting side, theft resistance, and finish." },
      { name: "Toilet Seat Cover Dispensers", description: "Wall or partition-mounted dispensers for public-facing hygiene programs.", configurations: "Surface-mounted, recessed, and combination-unit formats.", specify: "Refill type, capacity, mounting position, projection, and finish." },
      { name: "Combination Toilet Accessories", description: "Integrated units that consolidate tissue, seat covers, and sanitary disposal functions.", configurations: "Recessed, semi-recessed, partition-mounted, and dual-access.", specify: "Wall depth, compartment side, service access, functions, and finish." },
      { name: "Napkin/Tampon Dispensers", description: "Commercial dispensers supporting free-vend or controlled-vend menstrual product access.", configurations: "Surface-mounted, recessed, dual-product, and single-product.", specify: "Vend operation, product capacity, mounting, payment-free requirements, and finish." },
      { name: "Partition Hardware", description: "Replacement and project hardware for doors, panels, pilasters, and attachment points.", configurations: "Latches, hinges, brackets, strikes, pulls, bumpers, and fasteners.", specify: "Partition brand, material, dimensions, handing, finish, and existing-hole pattern." },
      { name: "Urinal Screens", description: "Privacy panels that coordinate with partition materials and restroom layouts.", configurations: "Wall-hung, post-supported, floor-supported, and material-matched.", specify: "Material, size, support method, finish, and wall backing." },
    ],
  },
  {
    id: "mirrors-storage",
    number: "05",
    name: "Mirrors, Hooks & Storage",
    intro: "Finishing components that improve visibility, convenience, storage, and day-to-day usability.",
    items: [
      { name: "Mirrors", description: "Commercial mirrors for lavatories, accessible stations, full-wall installations, and specialty environments.", configurations: "Framed, frameless, fixed-tilt, adjustable-tilt, LED, and full-width.", specify: "Glass type, frame finish, dimensions, mounting height, backing, and lighting." },
      { name: "Hooks", description: "Compact convenience hardware for compartments, showers, changing rooms, and staff facilities.", configurations: "Single, double, concealed-mount, bumper-hook, and security styles.", specify: "Load expectations, projection, location, mounting substrate, and finish." },
      { name: "Shelves", description: "Commercial storage surfaces for phones, personal items, changing areas, and hygiene supplies.", configurations: "Wall-mounted, mirror-integrated, corner, and hook-and-shelf combinations.", specify: "Length, depth, edge profile, support, finish, and mounting height." },
      { name: "Custodial Accessories", description: "Utility products for janitorial spaces and maintenance workflows adjacent to the restroom.", configurations: "Mop and broom holders, utility hooks, shelves, and supply storage.", specify: "Capacity, wall backing, corrosion resistance, room layout, and finish." },
    ],
  },
  {
    id: "family-specialty",
    number: "06",
    name: "Family, Healthcare & Specialty",
    intro: "Purpose-built components for family restrooms, caregiving, healthcare, specialty hygiene, and inclusive facilities.",
    items: [
      { name: "Baby Changing Stations", description: "Fold-down changing surfaces for family restrooms and public facilities.", configurations: "Horizontal, vertical, recessed, and surface-mounted.", specify: "Open clearance, wall backing, mounting height, capacity documentation, and accessory kit." },
      { name: "Adult Changing Stations", description: "Larger changing platforms for inclusive public, healthcare, recreation, and transportation facilities.", configurations: "Fixed-height, height-adjustable, wall-mounted, and freestanding.", specify: "Room size, clearances, power, structural support, lift range, and care workflow." },
      { name: "Healthcare Accessories", description: "Specialty fixtures for patient, staff, behavioral health, and clinical restroom environments.", configurations: "Security-focused, ligature-resistant, bariatric, and institutional products.", specify: "Facility standard, risk profile, cleanability, mounting, and approved product requirements." },
      { name: "Specialty Dispensers & Fixtures", description: "Project-specific accessories that complete unique commercial restroom programs.", configurations: "Cup dispensers, facial tissue, glove boxes, shelf units, and custom combinations.", specify: "Consumable format, capacity, dimensions, mounting, finish, and service access." },
      { name: "Replacement Parts", description: "Targeted components that help restore compatible dispensers, partitions, and restroom accessories.", configurations: "Locks, keys, spindles, covers, springs, fasteners, and service parts.", specify: "Manufacturer, model number, photos, dimensions, finish, and existing condition." },
    ],
  },
];

export type AccessoryCategory = {
  id: string;
  name: string;
  image: string;
  imageAlt: string;
  href: string;
};

export const accessoryCategories: AccessoryCategory[] = [
  {
    id: "baby-changing-stations",
    name: "Baby Changing Stations",
    image: "/manus-storage/01-baby-changing-stations_b253f371.webp",
    imageAlt: "Commercial wall-mounted baby changing station shown open and closed",
    href: "/commercial-restroom-accessories/family-specialty",
  },
  {
    id: "bath-shower",
    name: "Bath & Shower",
    image: "/manus-storage/02-bath-shower_795c6269.webp",
    imageAlt: "Commercial shower accessories including rods, seats, and support fixtures",
    href: "/commercial-restroom-accessories/accessibility-safety",
  },
  {
    id: "facial-tissue-dispensers",
    name: "Facial Tissue Dispensers",
    image: "/manus-storage/03-facial-tissue-dispensers_8d65512e.webp",
    imageAlt: "Commercial stainless steel facial tissue dispenser",
    href: "/commercial-restroom-accessories/family-specialty",
  },
  {
    id: "flush-valves",
    name: "Flush Valves",
    image: "/manus-storage/04-flush-valves_ab8fd485.webp",
    imageAlt: "Commercial chrome manual and sensor-operated flush valves",
    href: "/commercial-restroom-accessories/handwashing-hygiene",
  },
  {
    id: "grab-bars",
    name: "Grab Bars",
    image: "/manus-storage/05-grab-bars_627c4cd0.webp",
    imageAlt: "Commercial stainless steel straight and swing-up grab bars",
    href: "/commercial-restroom-accessories/accessibility-safety",
  },
  {
    id: "hand-dryers",
    name: "Hand Dryers",
    image: "/manus-storage/06-hand-dryers_612b96a9.webp",
    imageAlt: "Commercial wall-mounted electric hand dryers",
    href: "/commercial-restroom-accessories/handwashing-hygiene",
  },
  {
    id: "hooks-shelves-racks",
    name: "Hooks, Shelves & Racks",
    image: "/manus-storage/07-hooks-shelves-racks_2abc9491.webp",
    imageAlt: "Commercial restroom hooks, shelves, and utility racks",
    href: "/commercial-restroom-accessories/mirrors-storage",
  },
  {
    id: "mirrors",
    name: "Mirrors",
    image: "/manus-storage/08-mirrors_881f8df7.webp",
    imageAlt: "Commercial framed and frameless restroom mirrors",
    href: "/commercial-restroom-accessories/mirrors-storage",
  },
  {
    id: "paper-towel-dispensers",
    name: "Paper Towel Dispensers",
    image: "/manus-storage/09-paper-towel-dispensers_6a1d7b76.webp",
    imageAlt: "Commercial wall-mounted paper towel dispensers in multiple configurations",
    href: "/commercial-restroom-accessories/paper-waste",
  },
  {
    id: "restroom-signs",
    name: "Restroom Signs",
    image: "/manus-storage/10-restroom-signs_6e0d7034.webp",
    imageAlt: "Commercial restroom identification and accessibility signs",
    href: "/commercial-restroom-accessories/compartment-accessories",
  },
  {
    id: "soap-dispensers",
    name: "Soap Dispensers",
    image: "/manus-storage/11-soap-dispensers_f274b0ac.webp",
    imageAlt: "Commercial counter-mounted and wall-mounted soap dispensers",
    href: "/commercial-restroom-accessories/handwashing-hygiene",
  },
  {
    id: "toilet-paper-dispensers",
    name: "Toilet Paper Dispensers",
    image: "/manus-storage/12-toilet-paper-dispensers_d83a3b1f.webp",
    imageAlt: "Commercial single-roll and multi-roll toilet paper dispensers",
    href: "/commercial-restroom-accessories/compartment-accessories",
  },
  {
    id: "toilet-seat-cover-dispensers",
    name: "Toilet Seat Cover Dispensers",
    image: "/manus-storage/13-toilet-seat-cover-dispensers_51b72697.webp",
    imageAlt: "Commercial toilet seat cover dispensers in surface-mounted and recessed styles",
    href: "/commercial-restroom-accessories/compartment-accessories",
  },
  {
    id: "sanitary-product-vendors-disposals",
    name: "Sanitary Product Vendors & Disposals",
    image: "/manus-storage/14-sanitary-product-vendors-disposals_98916707.webp",
    imageAlt: "Commercial menstrual product vendors and sanitary disposal units",
    href: "/commercial-restroom-accessories/compartment-accessories",
  },
  {
    id: "waste-receptacles-liners",
    name: "Waste Receptacles & Liners",
    image: "/manus-storage/15-waste-receptacles-liners_deee7cc9.webp",
    imageAlt: "Commercial restroom waste receptacles and removable liners",
    href: "/commercial-restroom-accessories/paper-waste",
  },
];

export type AccessoryShoppingZone = {
  id: "in-the-stall" | "at-the-sink" | "roomwide-specialty";
  title: string;
  shortTitle: string;
  description: string;
  categoryIds: AccessoryCategory["id"][];
};

export const accessoryShoppingZones: AccessoryShoppingZone[] = [
  {
    id: "in-the-stall",
    title: "In the stall",
    shortTitle: "Stall essentials",
    description: "Start with the fixtures used inside toilet compartments and around the partition line.",
    categoryIds: [
      "toilet-paper-dispensers",
      "toilet-seat-cover-dispensers",
      "sanitary-product-vendors-disposals",
      "grab-bars",
      "restroom-signs",
    ],
  },
  {
    id: "at-the-sink",
    title: "At the sink",
    shortTitle: "Lavatory zone",
    description: "Coordinate the handwashing wall, paper handling, drying, and mirror package.",
    categoryIds: [
      "soap-dispensers",
      "paper-towel-dispensers",
      "hand-dryers",
      "mirrors",
      "waste-receptacles-liners",
    ],
  },
  {
    id: "roomwide-specialty",
    title: "Roomwide & specialty",
    shortTitle: "Support spaces",
    description: "Finish the room with shower, family, utility, and supporting restroom components.",
    categoryIds: [
      "baby-changing-stations",
      "bath-shower",
      "facial-tissue-dispensers",
      "flush-valves",
      "hooks-shelves-racks",
    ],
  },
];

export type PartitionManufacturer = {
  id: string;
  number: string;
  name: string;
  logo: string;
  logoAlt: string;
  logoWidth: number;
  logoHeight: number;
  scope: string;
};

export const partitionManufacturers: PartitionManufacturer[] = [
  {
    id: "bobrick-partitions",
    number: "01",
    name: "Bobrick",
    logo: "/manus-storage/bobrick_2d36e88d.png",
    logoAlt: "Bobrick partition systems logo",
    logoWidth: 1250,
    logoHeight: 700,
    scope: "HPL, compact laminate, and composite systems",
  },
  {
    id: "bradley-partitions",
    number: "02",
    name: "Bradley",
    logo: "/manus-storage/bradley_corporation_fd22722c.png",
    logoAlt: "Bradley toilet partitions logo",
    logoWidth: 1200,
    logoHeight: 1500,
    scope: "Phenolic, stainless steel, and Euro systems",
  },
  {
    id: "asi-global-partitions",
    number: "03",
    name: "ASI Global Partitions",
    logo: "/manus-storage/asi_global_partitions_2ec250f4.png",
    logoAlt: "ASI Global Partitions logo",
    logoWidth: 336,
    logoHeight: 90,
    scope: "Metal, laminate, phenolic, and HDPE systems",
  },
  {
    id: "hadrian-partitions",
    number: "04",
    name: "Hadrian",
    logo: "/manus-storage/hadrian_58d29d08.svg",
    logoAlt: "Hadrian toilet partitions logo",
    logoWidth: 432,
    logoHeight: 101,
    scope: "Steel, stainless steel, HDPE, and phenolic",
  },
  {
    id: "scranton-products-partitions",
    number: "05",
    name: "Scranton Products",
    logo: "/manus-storage/scranton_products_51673308.png",
    logoAlt: "Scranton Products partition systems logo",
    logoWidth: 340,
    logoHeight: 86,
    scope: "HDPE partition and privacy systems",
  },
  {
    id: "metpar-partitions",
    number: "06",
    name: "Metpar",
    logo: "/manus-storage/metpar_c63e2b82.png",
    logoAlt: "Metpar toilet partitions logo",
    logoWidth: 6426,
    logoHeight: 4205,
    scope: "Steel, stainless steel, and phenolic systems",
  },
  {
    id: "all-american-metal-partitions",
    number: "07",
    name: "All American Metal",
    logo: "/manus-storage/aamco_all_american_metal_8dc0a34d.svg",
    logoAlt: "All American Metal toilet partitions logo",
    logoWidth: 500,
    logoHeight: 114,
    scope: "Metal, laminate, phenolic, and solid plastic",
  },
];

export type AccessoryBrand = {
  id: string;
  number: string;
  name: string;
  logo: string;
  logoAlt: string;
  logoWidth: number;
  logoHeight: number;
  scope: "Washroom accessories" | "Commercial hand drying" | "Restroom partition systems";
  summary: string;
  productTypes: string[];
  categoryIds: string[];
};

export const accessoryBrands: AccessoryBrand[] = [
  {
    id: "bobrick",
    number: "01",
    name: "Bobrick",
    logo: "/manus-storage/bobrick-logo_a813f5b3.webp",
    logoAlt: "Bobrick logo",
    logoWidth: 200,
    logoHeight: 150,
    scope: "Washroom accessories",
    summary: "Commercial washroom accessories and toilet partition systems for coordinated public, institutional, and workplace restrooms.",
    productTypes: ["Dispensers and waste units", "Grab bars and mirrors", "Changing stations", "Partition systems"],
    categoryIds: accessoryGroups.map((group) => group.id),
  },
  {
    id: "asi-group",
    number: "02",
    name: "ASI Group",
    logo: "/manus-storage/asi-group-logo_77ed7f23.webp",
    logoAlt: "ASI Group logo",
    logoWidth: 200,
    logoHeight: 150,
    scope: "Washroom accessories",
    summary: "Commercial washroom accessories and partition systems for complete restroom packages and coordinated specifications.",
    productTypes: ["Dispensers and disposals", "Grab bars and mirrors", "Hand dryers", "Partition systems"],
    categoryIds: accessoryGroups.map((group) => group.id),
  },
  {
    id: "bradley",
    number: "03",
    name: "Bradley",
    logo: "/manus-storage/bradley-logo_b64719cc.webp",
    logoAlt: "Bradley logo",
    logoWidth: 200,
    logoHeight: 150,
    scope: "Washroom accessories",
    summary: "Commercial washroom accessories for accessibility, handwashing, compartment, and facility-maintenance programs.",
    productTypes: ["Grab bars", "Dispensers", "Mirrors", "Hand dryers and combination units"],
    categoryIds: accessoryGroups.map((group) => group.id),
  },
  {
    id: "dyson",
    number: "04",
    name: "Dyson",
    logo: "/manus-storage/dyson-logo_b6280d5a.webp",
    logoAlt: "Dyson logo",
    logoWidth: 200,
    logoHeight: 150,
    scope: "Commercial hand drying",
    summary: "Airblade commercial hand-drying systems for facilities planning low-touch, paper-reduction, and high-traffic washrooms.",
    productTypes: ["Airblade hand dryers", "Hands-under systems", "Hands-in systems", "Coordinated hand drying"],
    categoryIds: ["handwashing-hygiene"],
  },
  {
    id: "hadrian",
    number: "05",
    name: "Hadrian",
    logo: "/manus-storage/hadrian-logo_ecc84720.webp",
    logoAlt: "Hadrian logo",
    logoWidth: 200,
    logoHeight: 150,
    scope: "Restroom partition systems",
    summary: "Commercial toilet partition systems that can be coordinated with hardware, accessories, and the complete restroom scope.",
    productTypes: ["Powder coated steel", "Stainless steel", "Solid plastic (HDPE)", "Phenolic partitions"],
    categoryIds: ["compartment-accessories"],
  },
  {
    id: "scranton-products",
    number: "06",
    name: "Scranton Products",
    logo: "/manus-storage/scranton-products-logo_d3444bda.webp",
    logoAlt: "Scranton Products logo",
    logoWidth: 200,
    logoHeight: 150,
    scope: "Restroom partition systems",
    summary: "HDPE toilet partitions and related commercial restroom systems for durable, moisture-resistant project applications.",
    productTypes: ["HDPE toilet partitions", "Lockers", "Shower stalls", "Dressing and privacy systems"],
    categoryIds: ["compartment-accessories"],
  },
];

export const primaryAccessoryBrands = accessoryBrands.filter((brand) =>
  ["bobrick", "asi-group", "bradley"].includes(brand.id),
);

export const projectTypes = [
  "New construction",
  "Renovation or replacement",
  "Repair parts",
  "Accessories only",
  "Not sure yet",
] as const;

export const materialPreferences = ["Not sure — help me choose", ...materials.map((material) => material.name)] as const;

export const serviceRegions = ["Northeast", "Mid-Atlantic", "Southeast", "Midwest", "Southwest", "Mountain West", "West Coast", "Nationwide projects"] as const;
